export default function SchemaOrg() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://hoobuy.boutique';
  const logoUrl = 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/879fae149d7d175a673508cd1be74143.jpeg';

  const schema = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'WebSite',
        name: 'Hoobuy Boutique',
        url: siteUrl,
        description: 'HoobuySpreadsheet 2026 — Lista Atualizada de Produtos da China. Descubra sneakers, streetwear e produtos virais.',
        inLanguage: 'pt-PT',
        potentialAction: {
          '@type': 'SearchAction',
          target: `${siteUrl}/search?q={search_term_string}`,
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@type': 'Organization',
        name: 'Hoobuy Boutique',
        url: siteUrl,
        logo: logoUrl,
        sameAs: [
          'https://kaspreadsheet.com',
        ],
      },
      {
        '@type': 'WebPage',
        name: 'HoobuySpreadsheet 2026 — Lista Atualizada de Produtos da China',
        description: 'HoobuySpreadsheet atualizado 2026: a melhor lista de compras da China. Sneakers, streetwear, hoodies e produtos virais aos melhores preços.',
        url: siteUrl,
        inLanguage: 'pt-PT',
        isPartOf: {
          '@type': 'WebSite',
          name: 'Hoobuy Boutique',
          url: siteUrl,
        },
      },
      {
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: 'O que é o HoobuySpreadsheet?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'O HoobuySpreadsheet é uma lista curada e atualizada diariamente com os melhores produtos disponíveis para compra na China, incluindo sneakers, streetwear e artigos virais.',
            },
          },
          {
            '@type': 'Question',
            name: 'O HoobuySpreadsheet é atualizado com que frequência?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'O HoobuySpreadsheet é atualizado diariamente com novos produtos, tendências do TikTok e achados das redes sociais.',
            },
          },
          {
            '@type': 'Question',
            name: 'Como posso aceder ao HoobuySpreadsheet?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Pode aceder ao HoobuySpreadsheet completo através do nosso site principal em kaspreadsheet.com, onde encontrará todas as categorias e produtos atualizados.',
            },
          },
          {
            '@type': 'Question',
            name: 'É seguro comprar usando o HoobuySpreadsheet?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Sim, o HoobuySpreadsheet inclui apenas vendedores verificados para garantir uma experiência de compra segura. Recomendamos sempre verificar as avaliações antes de comprar.',
            },
          },
        ],
      },
    ],
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}